import constate from 'constate';
import { useCallback, useState } from 'react';

import { IQuotePart } from 'quotes/types';

const useSelectedQuotePart = () => {
  const [selectedQuotePart, setSelectedQuotePart] = useState<IQuotePart | null>(null);

  const selectQuotePart = useCallback((part: IQuotePart) => setSelectedQuotePart(part), []);

  const clearSelectedQuotePart = () => setSelectedQuotePart(null);

  return {
    selectedQuotePart,
    selectQuotePart,
    clearSelectedQuotePart,
  };
};

export const [SelectedQuotePartProvider, useSelectedQuotePartContext] =
  constate(useSelectedQuotePart);
